'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _customSectionSharedFunctions = require('./customSectionSharedFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContributorsSection = function ContributorsSection(_ref) {
    var authors = _ref.authors,
        authenticators = _ref.authenticators,
        legalAuthenticator = _ref.legalAuthenticator,
        dataEnterer = _ref.dataEnterer,
        informants = _ref.informants,
        informationRecipients = _ref.informationRecipients,
        custodian = _ref.custodian,
        officeContacts = _ref.officeContacts;


    var renderAuthenticator = function renderAuthenticator(authenticator, index) {
        return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(
                'div',
                null,
                authenticator.entity ? (0, _customSectionSharedFunctions.renderEntity)(authenticator.entity) : null
            ),
            _react2.default.createElement(
                'div',
                { className: 'indent-10' },
                _react2.default.createElement(
                    'span',
                    null,
                    authenticator.signature ? authenticator.signature + " " : null
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    authenticator.signatureDate ? authenticator.signatureDate : null
                )
            )
        );
    };

    var renderAuthenticators = function renderAuthenticators(authenticators) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'span',
                { className: 'bold' },
                'Authenticators'
            ),
            _react2.default.createElement(
                'ul',
                null,
                authenticators.map(renderAuthenticator)
            ),
            _react2.default.createElement('br', null)
        );
    };

    var renderLegalAuthenticator = function renderLegalAuthenticator(legalAuthenticator) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'span',
                { className: 'bold' },
                'Legal Authenticator'
            ),
            _react2.default.createElement(
                'ul',
                null,
                renderAuthenticator(legalAuthenticator)
            ),
            _react2.default.createElement('br', null)
        );
    };

    var renderEntityWithTitle = function renderEntityWithTitle(entity, title) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'span',
                { className: 'bold' },
                title
            ),
            _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    (0, _customSectionSharedFunctions.renderEntity)(entity)
                )
            ),
            _react2.default.createElement('br', null)
        );
    };

    var renderEntityListWithTitle = function renderEntityListWithTitle(entityList, title) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'span',
                { className: 'bold' },
                title
            ),
            _react2.default.createElement(
                'ul',
                null,
                entityList.map(function (entity, index) {
                    return _react2.default.createElement(
                        'li',
                        { key: index },
                        (0, _customSectionSharedFunctions.renderEntity)(entity)
                    );
                })
            ),
            _react2.default.createElement('br', null)
        );
    };

    var renderAuthoringDevice = function renderAuthoringDevice(device) {
        return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                'span',
                null,
                'Authoring Device : '
            ),
            device.modelName ? device.modelName : null,
            device.modelName && device.softwareName ? _react2.default.createElement(
                'span',
                null,
                " "
            ) : null,
            device.softwareName ? device.softwareName : null
        );
    };

    var renderAuthor = function renderAuthor(author, index) {
        return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(
                'div',
                null,
                author.entity ? (0, _customSectionSharedFunctions.renderEntity)(author.entity) : null
            ),
            _react2.default.createElement(
                'div',
                { className: 'indent-10' },
                author.authoringDevice ? renderAuthoringDevice(author.authoringDevice) : null,
                author.effectiveTime ? _react2.default.createElement(
                    'div',
                    null,
                    "Date: " + author.effectiveTime
                ) : null,
                author.functionCode ? _react2.default.createElement(
                    'div',
                    null,
                    "Function Code: " + author.functionCode
                ) : null
            )
        );
    };

    var renderAuthors = function renderAuthors(authors, title) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'span',
                { className: 'bold' },
                title ? title : "Author(s)"
            ),
            _react2.default.createElement(
                'ul',
                null,
                authors.map(renderAuthor)
            ),
            _react2.default.createElement('br', null)
        );
    };

    return _react2.default.createElement(
        'div',
        { className: 'contributorsSection' },
        authors ? _react2.default.createElement(
            'div',
            null,
            renderAuthors(authors)
        ) : null,
        dataEnterer ? _react2.default.createElement(
            'div',
            null,
            renderEntityWithTitle(dataEnterer, "Data Enterer")
        ) : null,
        legalAuthenticator ? _react2.default.createElement(
            'div',
            null,
            renderLegalAuthenticator(legalAuthenticator)
        ) : null,
        authenticators && authenticators.length > 0 ? _react2.default.createElement(
            'div',
            null,
            renderAuthenticators(authenticators)
        ) : null,
        informants ? _react2.default.createElement(
            'div',
            null,
            renderEntityListWithTitle(informants, "Informants")
        ) : null,
        informationRecipients ? _react2.default.createElement(
            'div',
            null,
            renderEntityListWithTitle(informationRecipients, "Information Recipients")
        ) : null,
        custodian ? _react2.default.createElement(
            'div',
            null,
            renderEntityWithTitle(custodian, "Custodian")
        ) : null,
        authors ? _react2.default.createElement(
            'div',
            null,
            renderAuthors(authors, "Referring Provider(s)")
        ) : null,
        officeContacts ? _react2.default.createElement(
            'div',
            null,
            renderEntityListWithTitle(officeContacts, "Office Contacts")
        ) : null
    );
};

ContributorsSection.propTypes = {
    authors: _propTypes.array,
    authenticators: _propTypes.array,
    legalAuthenticator: _propTypes.object,
    dataEnterer: _propTypes.object, //entity
    informants: _propTypes.array, //list of Entitys
    informationRecipients: _propTypes.array, //list of Entities
    custodian: _propTypes.object, //entity
    officeContacts: _propTypes.array //list of entities
};

exports.default = ContributorsSection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/customSections/ContributorsSection.js
// module id = 1228
// module chunks = 0